import { List, Typography } from 'antd';

const { Text } = Typography;

const OnTimeDelivery = () => {

  const data = [
    'Siparişin “teslim edildi” yapıldığı zamana bakılır, “mağazaya ulaşıldı” yapıldığı süre dikkate alınmaz.',
    'Bir siparişin teslimat zamanı geçti ise sipariş Yeni statüsünde olsa dahi orana başarısız olarak yansır.',
    'İptal edilen siparişler buraya yansımaz.',
    'Günlük performansta 00:00’dan itibaren bakılan ana kadar işlem gören ve görmesi gereken siparişler üzerinden oran gösterilir.',
    'Aylık performansta ilgili ayın 1’inden itibaren o ana kadar olan siparişler üzerinden oran gösterilir.',
    'İlgili oran merkez tarafından belirlenen hedef değerinden daha yüksekse yeşil, düşükse kırmızı renk ile gösterilir.',
];

  return (<List
    className="demo-loadmore-list"
    itemLayout="horizontal"
    dataSource={data}
  >
    <List.Item.Meta
      style={{ marginBottom: 10 }}
      title={
        <Text strong style={{ fontSize: 16 }}>
          İlgili dağıtım tarihine ait siparişlerin ne kadarının uygulamada gösterilen
          Son teslimat zamanına kadar teslim edilip edilmediğini gösteren orandır.
        </Text>
      }
    />
    <ul>
      {data.map((item, index) => (<li style={{ color: '#555555', fontWeight: 500 }} key={index}>{item}</li>))}
    </ul>
  </List>);
};

export default OnTimeDelivery;
